import Sha from 'jssha'
import config from '../config'

// historical reasons
const hashPassword = function (pass) {
  const hash = new Sha('SHA-1', 'TEXT')
  hash.update(pass)
  return hash.getHash('HEX')
}

export default function (axios) {
  return {
    login: async function ({ mail, pass }) {
      const data = new FormData()
      data.append('mail', mail)
      data.append('pass', hashPassword(pass))
      // data.append('pass',pass)

      const response = await axios({
        method: 'post',
        url: config.serverUrl + '/api/user/login',
        data: data,
        withCredentials: true
      })

      // "result" ist object -> there is no error
      if (typeof response.data.result !== 'object') {
        return false
      } else {
        return Object.values(response.data.result)[0]
      }
    },
    logout: async function () {
      return axios({
        method: 'get',
        url: config.serverUrl + '/api/user/logout',
        withCredentials: true
      })
    },
    register: async function ({ mail, pass, lastName }) {
      const data = new FormData()
      data.append('mail', mail)
      data.append('pass', hashPassword(pass))
      // data.append('pass', pass)
      data.append('lastName', lastName)

      const response = await axios({
        method: 'post',
        url: config.serverUrl + '/api/user/register',
        data: data,
        withCredentials: true
      })

      // "result" ist object -> there is no error
      if (typeof response.data.result !== 'object') {
        return false
      } else {
        return Object.values(response.data.result)[0]
      }
    },
    passwordReset: async function ({ mail }) {
      const data = new FormData()
      data.append('mail', mail)

      return axios({
        method: 'post',
        url: config.serverUrl + '/api/user/passwordreset',
        data: data,
        withCredentials: true
      })
    },
    async getToken () {
      return (await axios({
        method: 'get',
        url: config.serverUrl + '/session/token',
        withCredentials: true
      })).data
    },
    async getUser ({ id }) {
      const response = await axios({
        method: 'get',
        url: config.serverUrl + '/user/' + id + '?_format=json',
        withCredentials: true
      })

      if (!response.data.mail) {
        return null
      } else {
        return response.data
      }
    }
  }
}
